module.exports = __webpack_public_path__ + "img/8.c9a7adeb.png";